export default {
  /**
   * Store identifier
   * @type {String}
   */
  id: 'accounts',
  /**
   * Current session
   * @type {Session}
   */
  session: null,
  /**
   * Security guardian initialized with the logged in account
   * @type {Guardian}
   */
  guardian: null,
  /**
   * Login error
   * @type {LoginError}
   */
  loginError: null,
  /**
   * Login message
   * @type {String}
   */
  loginMessage: null,
  /**
   * Indicates an ongoing login progress
   * @type {Boolean}
   */
  isLoggingIn: false,
  /**
   * Indicates an ongoing logout progress
   * @type {Boolean}
   */
  isLoggingOut: false,
  /**
   * All accounts, available to administrators
   * @type {Account[]}
   */
  accounts: [],
  /**
   * Security profiles which can be assigned to avatars
   * @type {SecurityProfile[]}
   */
  securityProfiles: []
}
